import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {FormAbstract} from '../../../core/abstracts/form.abstract';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionConfirmTypesEnum} from '../../enums/action-confirm-types.enum';

@Component({
  selector: 'app-custom-confirm-modal',
  templateUrl: './custom-confirm-modal.component.html',
  styleUrls: ['./custom-confirm-modal.component.scss']
})
export class CustomConfirmModalComponent extends FormAbstract implements OnInit {


  @Input() title;
  @Input() confirmText = 'Para confirmar, digite CONFIRM_TEXT no campo de entrada de texto.';
  @Input() buttonLabel;
  @Input() successLabel;
  @Input() btnClass = 'btn-danger'

  @Input() entityId;
  @Input() url;
  @Input() actionType = ActionConfirmTypesEnum.DELETE;
  // Quando informado, a confirmação faz DELETE direto nesta url (sem pedido de ação/hash do servidor)
  @Input() deleteUrl: string;

  @Input() actionBeforeSubmit: VoidFunction = () => {}

  // Código de verificação
  code = '';
  // O rash que o servidor me envia
  hashData = '';


  constructor(public activeModal: NgbActiveModal,
              public route: ActivatedRoute, elementRef: ElementRef) {
    super(route, elementRef);
  }

  ngOnInit(): void {
    this.createForm();
    this.loadData();

  }


  save(data: any) {
    this.actionBeforeSubmit();
    if (this.deleteUrl) {
      this.crudService.delete(this.deleteUrl).subscribe(() => {
        this.toastService.sendSuccess(this.successLabel);
        this.activeModal.close();
      });
      return;
    }
    this.crudService.put(`${this.url}/${this.entityId}/actions/${this.actionType}/${this.hashData}/${data.userKey}`, {}).subscribe(response => {
      this.toastService.sendSuccess(this.successLabel);
      this.activeModal.close();
    });

  }

  createForm() {
    this.form = new FormGroup({
      userKey: new FormControl(null, [Validators.required]),
    }, this.sameValue.bind(this));


  }

  sameValue(group: FormGroup): { [s: string]: boolean } {

    const userKey = group.get('userKey').value;
    if (userKey != this.code) {
      group.get('userKey').setErrors({notSame: true});
    }

    return null;
  }

  loadData() {
    if (this.deleteUrl) {
      this.code = 'EXCLUIR';
      return;
    }

    this.crudService.get(`${this.url}/${this.entityId}/actions/${this.actionType}`).subscribe((response: any) => {
      this.hashData = response.hashData;
      this.code = response.code;
    });


  }


}
